/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_listen_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — SILENT and LISTEN are made from exactly the same six letters (L, I, S, T, E, N), just reordered, which is why this is one of the most frequently cited anagram pairs in English. ENLIST, TINSEL, and INLETS are also full anagrams of both words.`)
};

const es_wu_c_listen_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí —SILENT y LISTEN están formadas exactamente por las mismas seis letras (L, I, S, T, E, N), solo reordenadas, por lo que este es uno de los pares de anagramas más citados del inglés. ENLIST, TINSEL e INLETS también son anagramas completos de ambas palabras.`)
};

const de_wu_c_listen_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — SILENT und LISTEN bestehen aus genau denselben sechs Buchstaben (L, I, S, T, E, N), nur in anderer Reihenfolge, weshalb dies eines der meistzitierten Anagramm-Paare im Englischen ist. ENLIST, TINSEL und INLETS sind ebenfalls vollständige Anagramme beider Wörter.`)
};

const nl_wu_c_listen_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — SILENT en LISTEN zijn gemaakt van exact dezelfde zes letters (L, I, S, T, E, N), alleen in een andere volgorde, wat verklaart waarom dit een van de meest aangehaalde anagramparen in het Engels is. ENLIST, TINSEL en INLETS zijn ook volledige anagrammen van beide woorden.`)
};

const fr_wu_c_listen_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui — SILENT et LISTEN sont formés exactement des mêmes six lettres (L, I, S, T, E, N), simplement réordonnées, ce qui explique pourquoi cette paire est l'une des plus citées en anglais. ENLIST, TINSEL et INLETS sont eux aussi des anagrammes complètes des deux mots.`)
};

const it_wu_c_listen_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì — SILENT e LISTEN sono formate esattamente dalle stesse sei lettere (L, I, S, T, E, N), solo riordinate, ed è per questo che è una delle coppie di anagrammi più citate in inglese. Anche ENLIST, TINSEL e INLETS sono anagrammi completi di entrambe le parole.`)
};

const pt_br2_wu_c_listen_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — SILENT e LISTEN são formadas exatamente pelas mesmas seis letras (L, I, S, T, E, N), apenas reordenadas, e é por isso que esse é um dos pares de anagramas mais citados do inglês. ENLIST, TINSEL e INLETS também são anagramas completos de ambas as palavras.`)
};

const pt_wu_c_listen_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — SILENT e LISTEN são formadas exatamente pelas mesmas seis letras (L, I, S, T, E, N), apenas reordenadas, razão pela qual este é um dos pares de anagramas mais citados em inglês. ENLIST, TINSEL e INLETS também são anagramas completos de ambas as palavras.`)
};

const ja_wu_c_listen_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい — SILENTとLISTENはまったく同じ6文字（L, I, S, T, E, N）を並べ替えただけで作られており、これが英語で最も頻繁に引き合いに出されるアナグラムペアの一つである理由です。ENLIST、TINSEL、INLETSもどちらの単語とも完全なアナグラムの関係にあります。`)
};

const zh_wu_c_listen_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的——SILENT 和 LISTEN 由完全相同的六个字母（L、I、S、T、E、N）组成，只是顺序不同，这也是为什么它是英语中被引用最多的易位构词对之一。ENLIST、TINSEL 和 INLETS 同样是这两个单词的完整易位构词。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_listen_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_listen_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_listen_faq2_a", locale)
	if (locale === "en") return en_wu_c_listen_faq2_a(inputs)
	if (locale === "es") return es_wu_c_listen_faq2_a(inputs)
	if (locale === "de") return de_wu_c_listen_faq2_a(inputs)
	if (locale === "nl") return nl_wu_c_listen_faq2_a(inputs)
	if (locale === "fr") return fr_wu_c_listen_faq2_a(inputs)
	if (locale === "it") return it_wu_c_listen_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_listen_faq2_a(inputs)
	if (locale === "pt") return pt_wu_c_listen_faq2_a(inputs)
	if (locale === "ja") return ja_wu_c_listen_faq2_a(inputs)
	return zh_wu_c_listen_faq2_a(inputs)
};